/** Godot 4.6.3's `SpriteFrames` resource facts, apart from the Sprite sheet frames in `spriteFrames.ts`. */
/**
 * `SPRITE_FRAME_MINIMUM_DURATION` (`scene/resources/sprite_frames.h:35`): `_set_animations` floors
 * each frame's `duration` at it (`sprite_frames.cpp:225`).
 */
export const SPRITE_FRAME_MINIMUM_DURATION = 0.01;
//# sourceMappingURL=spriteFramesResource.js.map